export default {
    ROUTE_ACCOUNT_PAGE: '/account',
    ROUTE_ADMIN_PAGE: '/adminHotelList',
    ROUTE_AIRPORTS_PAGE: '/airports',
    ROUTE_ATTRACTIONS_PAGE: '/attractions',
    ROUTE_BASE_RATEPLANS_PAGE: '/baseRateplans',
    ROUTE_BASE_RATEPLANS_TIERED_PAGE: '/baseRateplansTiered',
    ROUTE_BASE_RATEPLANS_LINKED_PAGE: '/baseRateplansLinked',
    ROUTE_UPDATE_ONBOARDING_PAGE: '/updateOnboarding',
    ROUTE_BOX_INVENTORY_PAGE: '/boxInventory',
    ROUTE_SRP_INVENTORY_PAGE: '/srpInventory',
    ROUTE_BUSINESSES_PAGE: '/businesses',
    ROUTE_CRIBS_PAGE: '/cribs',
    ROUTE_DESTINATIONS_PAGE: '/hotelDestinations',
    ROUTE_DRIVING_DIRECTIONS_PAGE: '/drivingDirections',
    ROUTE_EMERGENCY_CONTACTS_PAGE: '/emergencyContacts',
    ROUTE_EXTENDED_DRIVING_DIRECTIONS_PAGE: '/extendedDrivingDirections',
    ROUTE_EXTRA_CHARGES_PAGE: '/extraCharges',
    ROUTE_EXTRA_PERSON_PAGE: '/extraPerson',
    ROUTE_FEEDBACK_PAGE: '/feedback',
    ROUTE_GROUP_POLICY_PAGE: '/groupPolicy',
    ROUTE_GUARANTEE_CANCEL_POLICY_PAGE: '/guaranteeCancelPolicy',
    ROUTE_AGE_TIERS_PAGE: '/ageTiers',
    ROUTE_HOME_PAGE: '/',
    ROUTE_HOTEL_ALERTS_PAGE: '/hotelAlerts',
    ROUTE_HOTEL_AMENITIES_PAGE: '/hotelAmenities',
    ROUTE_HOTEL_CONTACTS_PAGE: '/hotelContacts',
    ROUTE_HOTEL_DISPLAY_LOCATION_PAGE: '/hotelDisplayLocation',
    ROUTE_HOTEL_INFO_PAGE: '/hotelInfo',
    ROUTE_HOTEL_ONLINE_DISPLAY_PAGE: '/hotelOnlineDisplay',
    ROUTE_HOTEL_TAXES_PAGE: '/hotelTaxes',
    ROUTE_HOTEL_CONTENT_PAGE: '/hotelContent',
    ROUTE_HOTEL_CONTENT_WEDDING_PAGE: '/hotelContentWedding',
    ROUTE_INVENTORY_CLOSEOUTS_PAGE: '/inventoryAlerts',
    ROUTE_LAUNCH_ONBOARDING_APPLICATION_PAGE: '/launchOnboardingApplication',
    ROUTE_LOGOUT_PAGE: '/logout',
    ROUTE_LOUNGES_PAGE: '/lounges',
    ROUTE_MEETING_ROOMS_PAGE: '/meetingRooms',
    ROUTE_MEETING_ROOM_PAGE: '/meetingRoom',
    ROUTE_OKTA_CALLBACK: '/implicit/callback',
    ROUTE_ONBOARDING_CONTACT: '/onboardingContact',
    ROUTE_ONLINE_TRAVEL_AGENT_CONTACT: '/otaContact', 
    ROUTE_ONBOARDING_CONTACT_INITIAL: '/onboardingContactDetails',
    ROUTE_OSD_CONTACT: '/osdContact',
    ROUTE_OTA_RATE_PROGRAMS_PAGE: '/otaRatePrograms',
    ROUTE_OTHER_RATEPLANS_PAGE: '/otherRateplans',
    ROUTE_PET_POLICY_PAGE: '/petPolicy',
    ROUTE_POLICIES_PAGE: '/policies',
    ROUTE_RACK_RATES_PAGE: '/rackRates',
    ROUTE_RATEPLANS_PAGE: '/rateplans',
    ROUTE_RATEPLAN_BLACKOUTS_PAGE: '/blackouts',
    ROUTE_RESTAURANTS_PAGE: '/restaurants',
    ROUTE_SPA_PAGE: '/spa',
    ROUTE_ROLLAWAY_PAGE: '/rollaway',
    ROUTE_ROOM_TYPES_PAGE: '/roomTypes',
    ROUTE_ROOM_TYPE_BUCKETS_PAGE: '/roomTypeBuckets',
    ROUTE_ROOM_TYPE_BUCKET_PAGE: '/roomTypeBucket',
    ROUTE_ROOM_TYPE_PAGE: '/roomType',
    ROUTE_SALES_PITCH_PAGE: '/salesPitch',
    ROUTE_SUBMIT_FOR_REVIEW_PAGE: '/submitForReview',
    ROUTE_TERMS_AND_CONDITIONS_PAGE: '/termsAndConditions',
    ROUTE_USER_ERROR_PAGE: '/userError',
    ROUTE_LONG_DISTANCE_TRANSPORTATION_PAGE: '/longDistanceTransportation',
    ROUTE_LOCAL_TRANSPORTATION_PAGE: '/localTransportation',
    ROUTE_HISTORY_SEARCH_PAGE: '/searchHotelHistory',
    ROUTE_HISTORY_DETAILS_PAGE: '/searchHotelHistoryDetails',
    ROUTE_LAUNCH_CONFIGURE_PAGE: '/configure',
    ROUTE_RATE_PLAN_CONFIGURATION_PAGE: '/ratePlanConfiguration',
    ROUTE_RATES_CONFIGURATION_PAGE: '/ratesConfiguration',
    ROUTE_MASTER_BOX_CONFIGURATION_PAGE: '/masterBoxConfiguration',
}